import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "hero-body" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "columns is-centered" }
const _hoisted_4 = {
  class: "column is-6-tablet is-5-desktop is-4-widescreen",
  style: {"margin-top":"10%"}
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", { class: "is-size-4 has-text-centered" }, "Login form", -1)
const _hoisted_6 = { class: "field" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Email:", -1)
const _hoisted_8 = { class: "control has-icons-left" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "icon is-small is-left" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-envelope" })
], -1)
const _hoisted_10 = { class: "field" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Password:", -1)
const _hoisted_12 = { class: "control has-icons-left" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "icon is-small is-left" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-lock" })
], -1)
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<div class=\"field\"><label class=\"checkbox\"><input type=\"checkbox\"> Remember me </label></div><div class=\"field\"><button class=\"button is-info\">Login</button></div>", 2)
const _hoisted_16 = {
  key: 0,
  class: "message is-danger"
}
const _hoisted_17 = { class: "message-body" }
const _hoisted_18 = { class: "field" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Or ")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("register a new account")
const _hoisted_21 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("h3", { class: "is-size-4 has-text-centered" }, "Forgot Password?", -1)
const _hoisted_24 = {
  key: 0,
  class: "field"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "E-mail:", -1)
const _hoisted_26 = { class: "control has-icons-left" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", { class: "icon is-small is-left" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-envelope" })
], -1)
const _hoisted_28 = {
  key: 1,
  class: "message is-success"
}
const _hoisted_29 = { class: "message-body has-text-centered" }
const _hoisted_30 = {
  key: 2,
  class: "message is-danger"
}
const _hoisted_31 = { class: "message-body" }
const _hoisted_32 = {
  key: 3,
  class: "field"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "button is-info"
}, "Reset password", -1)
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = { class: "field" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", { class: "icon is-small is-left" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-angle-left" })
], -1)
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" Back ")
const _hoisted_38 = [
  _hoisted_36,
  _hoisted_37
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (!_ctx.forgotPassword)
              ? (_openBlock(), _createElementBlock("form", {
                  key: 0,
                  class: "box",
                  onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["prevent"]))
                }, [
                  _hoisted_5,
                  _createElementVNode("div", _hoisted_6, [
                    _hoisted_7,
                    _createElementVNode("div", _hoisted_8, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.data.email) = $event)),
                        class: "input",
                        required: ""
                      }, null, 512), [
                        [_vModelText, _ctx.data.email]
                      ]),
                      _hoisted_9
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createElementVNode("div", _hoisted_12, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.data.password) = $event)),
                        type: "password",
                        class: "input",
                        required: ""
                      }, null, 512), [
                        [_vModelText, _ctx.data.password]
                      ]),
                      _hoisted_13
                    ])
                  ]),
                  _hoisted_14,
                  (_ctx.error)
                    ? (_openBlock(), _createElementBlock("article", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.error), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _createVNode(_component_router_link, { to: "/register.html" }, {
                      default: _withCtx(() => [
                        _hoisted_20
                      ]),
                      _: 1
                    }),
                    _hoisted_21,
                    _hoisted_22,
                    _createElementVNode("a", {
                      href: "#",
                      onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.forgotPassword = true), ["prevent"]))
                    }, "Forgot Password?")
                  ])
                ], 32))
              : (_openBlock(), _createElementBlock("form", {
                  key: 1,
                  class: "box",
                  onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.resetPassword && _ctx.resetPassword(...args)), ["prevent"]))
                }, [
                  _hoisted_23,
                  (!_ctx.forgotPasswordSent)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _hoisted_25,
                        _createElementVNode("div", _hoisted_26, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.data.email) = $event)),
                            placeholder: "enter your e-mail address",
                            class: "input",
                            required: ""
                          }, null, 512), [
                            [_vModelText, _ctx.data.email]
                          ]),
                          _hoisted_27
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.forgotPasswordSent)
                    ? (_openBlock(), _createElementBlock("article", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.msg), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.error)
                    ? (_openBlock(), _createElementBlock("article", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.error), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.forgotPasswordSent)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, _hoisted_34))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("a", {
                      href: "#",
                      onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => {_ctx.forgotPassword = false; _ctx.forgotPasswordSent = false}, ["prevent"]))
                    }, _hoisted_38)
                  ])
                ], 32))
          ])
        ])
      ])
    ])
  ]))
}